'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToRemove = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.cancelSearch = cancelSearch;
exports.search = search;
exports.add = add;
exports.pop = pop;
exports.remove = remove;
exports.getSuggestions = getSuggestions;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = require('react-router-redux');

var _analytics = require('./analytics');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_SUGGESTIONS = 'ms/search/get_suggestions';
var GET_SUGGESTIONS_SUCCESS = 'ms/search/get_suggestions_success';
var GET_SUGGESTIONS_FAIL = 'ms/search/get_suggestions_fail';

var GET_ALL_TAGS = 'ms/search/get_all_tags';
var GET_ALL_TAGS_SUCCESS = 'ms/search/get_all_tags_success';
var GET_ALL_TAGS_FAIL = 'ms/search/get_all_tags_fail';

var SEARCH_CANCEL = 'ms/search/cancel';

var getSearch = function getSearch(routing) {
  var search = routing.routing.locationBeforeTransitions.query.search;


  if (!search) return [];
  if (!_ramda2.default.is(Array, search)) return [search];
  return search;
};

var getSearchWithoutTag = function getSearchWithoutTag(routing, tag) {
  var search = routing.routing.locationBeforeTransitions.query.search;


  if (!search || search === tag) return [];
  if (!_ramda2.default.is(Array, search)) return [search];
  search.splice(_ramda2.default.indexOf(tag, search), 1);
  return search;
};
var ToRemove = exports.ToRemove = ['coarse', 'cracked', 'fresh', 'patch', 'pothole', 'medieval', 'mud', 'rubble', 'displacement', 'edible', 'flowers', 'misc', 'moss', 'ocean', 'paper', 'construction', 'dirt', 'food', 'manmade', 'paper', 'trash', 'blood', 'crack', 'misc', 'pothole', 'rock', 'snow', 'wood', 'brushes', 'creature', 'books', 'debris', 'mud', 'rough', 'dirt', 'patches', 'potholes'];

var catstokeep = ['asphalt', 'brick', 'bush', 'climber', 'concrete', 'construction', 'debris', 'decals', 'fabric', 'floors', 'grass', 'ground', 'imperfections', 'metal', 'paintings', 'plants', 'plaster', 'plastic', 'rock', 'sand', 'scatter', 'snow', 'soil', 'stone', 'street', 'tiles', 'tree', 'wall', 'wood'];
var subcatstokeep = ['dried', 'fine', 'floor', 'grout', 'modern', 'painted', 'rough', 'damaged', 'painted', 'slab', 'smooth', 'nature', 'manhole cover', 'painted street lines', 'sidewalk', 'cardboard', 'crumpled', 'plain', 'coarse', 'fine', 'cracked', 'hardened', 'mulch', 'barriers', 'curbs', 'painted lines', 'sidewalk'];

function filterArchvizTags(tags) {
  var filteredTags = [];

  var _loop = function _loop() {
    var tag = tags[i].toLowerCase();
    var remove = false;

    for (j = 0; j < ToRemove.length; j++) {
      if (tag.indexOf(ToRemove[j]) != -1 || ToRemove[j].indexOf(tag) != -1) {
        remove = true;
        break;
      }
    }
    if (remove) {
      var toKeepCat = catstokeep.find(function (s) {
        return s.indexOf(tag) != -1 || tag.indexOf(s) != -1;
      });
      var toKeepSubCat = subcatstokeep.find(function (s) {
        return s.indexOf(tag) != -1 || tag.indexOf(s) != -1;
      });
      remove = !toKeepCat && !toKeepSubCat;
    }
    if (!remove) {
      filteredTags.push(tag);
    }
  };

  for (var i = 0; i < tags.length; i++) {
    var j;

    _loop();
  }
  return filteredTags;
}
var initialState = {
  tags: [],
  allTags: [],
  cachedSearches: [],
  suggestions: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _reactRouterRedux.LOCATION_CHANGE:
      var tagsFromSearch = _ramda2.default.ifElse(_ramda2.default.is(Array), _ramda2.default.identity, function (v) {
        return v ? [v] : [];
      })(action.payload.query.search);

      var tagFromCategory = _ramda2.default.ifElse(_ramda2.default.is(Array), _ramda2.default.identity, function (v) {
        return v ? [v] : [];
      })(action.payload.query.category);

      var tagFromSubCategory = _ramda2.default.ifElse(_ramda2.default.is(Array), _ramda2.default.identity, function (v) {
        return v ? [v] : [];
      })(action.payload.query.subCategory);

      var tagFromType = _ramda2.default.ifElse(_ramda2.default.is(Array), _ramda2.default.identity, function (v) {
        return v ? [v] : [];
      })(action.payload.query.type);

      return (0, _extends3.default)({}, state, {
        tags: _ramda2.default.uniq([].concat(tagFromType).concat(tagFromCategory).concat(tagFromSubCategory).concat(tagsFromSearch)),
        suggestions: []
      });

    case SEARCH_CANCEL:
      return (0, _extends3.default)({}, state, {
        tags: initialState.tags
      });

    case GET_SUGGESTIONS:
      return (0, _extends3.default)({}, state, {
        text: action.meta.text,
        gettingSuggestions: true,
        suggestions: []
      });

    case GET_SUGGESTIONS_SUCCESS:
      return action.meta.text !== state.text ? state : (0, _extends3.default)({}, state, {
        gettingSuggestions: false,
        cachedSearches: [].concat((0, _toConsumableArray3.default)(state.cachedSearches), [action.meta.text]),
        suggestions: _ramda2.default.compose(_ramda2.default.take(10), _ramda2.default.uniq)(action.result.suggestions)
      });

    case GET_SUGGESTIONS_FAIL:
      return action.meta.text !== state.text ? state : (0, _extends3.default)({}, state, {
        gettingSuggestions: false,
        suggestionsGetError: action.error
      });

    case GET_ALL_TAGS:
      return (0, _extends3.default)({}, state, {
        text: action.meta.text,
        gettingTags: true,
        suggestions: []
      });

    case GET_ALL_TAGS_SUCCESS:
      // console.log('ACTION ---- ' , action);
      return (0, _extends3.default)({}, state, {
        gettingTags: false,
        allTags: action.result
      });

    case GET_ALL_TAGS_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingSuggestions: false
      });

    default:
      return state;
  }
}

function cancelSearch() {
  return {
    type: SEARCH_CANCEL
  };
}

function search(tags) {
  return {
    type: SEARCH,
    tags: tags
  };
}

function add(searchTerm, isArchviz) {
  return function (dispatch, getState) {
    // Check if tag contains multiple spaces, to break search term into words
    var tags = searchTerm.trim().split(' ');
    var query = getState().routing.locationBeforeTransitions.query;
    var alreadyExists = _ramda2.default.cond([[_ramda2.default.equals(query.category), _ramda2.default.T], [_ramda2.default.equals(query.subCategory), _ramda2.default.T], [_ramda2.default.equals(query.type), _ramda2.default.T], [_ramda2.default.T, _ramda2.default.F]]);

    tags = _ramda2.default.filter(function (tag) {
      return !alreadyExists(tag);
    })(tags);

    var allTags = _ramda2.default.uniq(getSearch(getState()).concat(tags));
    dispatch((0, _analytics.metabase)(_analytics.WEB_SEARCH, { tags: allTags }));
    var pathName = getState().routing.locationBeforeTransitions.pathname;

    console.log(getState().routing.locationBeforeTransitions.query);

    if (pathName.indexOf('library/myscans') == -1 && pathName.indexOf('library/favorited') == -1) {
      pathName = isArchviz ? "/megascans/library/archviz" : "/megascans/library";
    }
    return tags.length && dispatch((0, _reactRouterRedux.push)({
      // pathname: '/megascans',

      pathname: pathName,
      query: (0, _extends3.default)({}, getState().routing.locationBeforeTransitions.query, {
        search: _ramda2.default.uniq(getSearch(getState()).concat(tags))
      })
    }));
  };
}

function pop() {
  return function (dispatch, getState) {
    var tags = getState().search.tags;
    if (!tags.length) return;

    var _tags = _ramda2.default.dropLast(1, tags);
    var query = getState().routing.locationBeforeTransitions.query;

    if (query.type && _tags.indexOf(query.type) === -1) {
      delete query.type;
    }

    if (query.category && _tags.indexOf(query.category) === -1) {
      delete query.category;
    }

    if (query.subCategory && _tags.indexOf(query.subCategory) === -1) {
      delete query.subCategory;
    }

    if (query.search) {
      query.search = _ramda2.default.filter(function (f) {
        return _tags.indexOf(f) > -1;
      })(query.search);
      if (!query.search.length) {
        delete query.search;
      }
    }

    return dispatch((0, _reactRouterRedux.push)({
      pathname: getState().routing.locationBeforeTransitions.pathname,
      query: query
    }));
  };
}

function remove(tag) {
  return function (dispatch, getState) {
    var query = getState().routing.locationBeforeTransitions.query;
    if (query.category === tag) {
      delete query.category;
      delete query.subCategory;
    }

    if (query.subCategory === tag) {
      delete query.subCategory;
    }

    if (query.type === tag) {
      delete query.type;
    }

    return dispatch((0, _reactRouterRedux.push)({
      pathname: getState().routing.locationBeforeTransitions.pathname,
      query: (0, _extends3.default)({}, query, {
        search: _ramda2.default.uniq(getSearchWithoutTag(getState(), tag))
      })
    }));
  };
}

function getSuggestions(text) {
  return function (dispatch, getState) {
    if (!text.length) return;
    var hasSearchedBefore = getState().search.cachedSearches.indexOf(text) !== -1;
    dispatch({
      type: GET_ALL_TAGS,
      meta: { text: text }
    });
    var dispatching = void 0;

    if (getState().search.allTags.length === 0) {
      getSearchedTagsFromServer().then(function (res) {
        var tags = getState().search.allTags;
        var facets = res.facets;
        var facetKey = void 0;
        var facet = void 0;
        var tag = void 0;
        for (facetKey in facets) {
          facet = facets[facetKey];
          for (tag in facet) {
            if (isNaN(tag) && tags.indexOf(tag) === -1) {
              // isNaN is check for numeric keys
              tags.push(tag);
            }
          }
        }

        dispatch({
          type: GET_ALL_TAGS_SUCCESS,
          result: filterArchvizTags(tags)
        });
      }).catch(function (err) {
        dispatch({
          type: GET_ALL_TAGS_FAIL,
          result: err
        });
      });
    } else {
      dispatching = dispatch({
        type: GET_SUGGESTIONS_SUCCESS,
        meta: { text: text },
        result: searchTag(getState().search.allTags, text)
      });
    }

    if (hasSearchedBefore) {
      // no need to call for this search again
      // the results are already in the cache
      return dispatching;
    }

    return getSearchedTagsFromServer(text).then(function (res) {
      var tags = getState().search.allTags;
      var tag = void 0;
      var val = void 0;
      var facet = void 0;
      var facetKey = void 0;
      var hits = res.hits;
      var ti = void 0;

      for (var i = 0; i < hits.length; i++) {
        var hit = hits[i];
        var obj = hit._highlightResult;

        for (facetKey in obj) {
          if (obj.hasOwnProperty(facetKey)) {
            facet = obj[facetKey];
            if (facetKey === '_tags') {
              for (ti = 0; ti < facet.length; ti++) {
                val = facet[ti].value.replace(/\<\/?em\>/g, '');
                if (tags.indexOf(val) === -1) {
                  tags.push(val);
                }
              }
            } else {
              val = facet.value && facet.value.replace(/\<\/?em\>/g, '');
              if (val && tags.indexOf(val) === -1) {
                tags.push(val);
              }
            }
          }
        }
      }

      dispatch({
        type: GET_ALL_TAGS_SUCCESS,
        result: filterArchvizTags(tags)
      });
    }).catch(function (err) {
      console.log('Error in getSearchedTagsFromServer: ', err);
      dispatch({
        type: GET_ALL_TAGS_FAIL,
        result: res
      });
    }).then(function (res) {
      return dispatch({
        type: GET_SUGGESTIONS_SUCCESS,
        meta: { text: text },
        result: searchTag(getState().search.allTags, text)
      });
    });
  };
}

function getSearchedTagsFromServer(text) {
  var algoliasearch = require('algoliasearch');
  var client = algoliasearch('6UJ1I5A072', 'd323ecb8180960ca69173bf184c8b294');
  var index = client.initIndex((0, _utils.getAlgoliaIndex)());
  var opts = void 0;

  if (text && text.length) {
    opts = {
      query: text,
      queryType: 'prefixLast',
      hitsPerPage: 1000,
      attributesToRetrieve: ['objectID']
    };
  } else {
    opts = {
      facets: '*',
      maxValuesPerFacet: 1000,
      page: 0,
      attributesToHighlight: [],
      attributesToRetrieve: [],
      hitsPerPage: 1
    };
  }
  return index.search(opts);
}

function searchTag(tags, text) {
  var firstResult = [];
  var secondResult = [];
  var i = void 0;
  var tagName = void 0;
  var index = void 0;
  var count = 0;
  text = text.toLowerCase();

  for (i = 0; i < tags.length; i++) {
    tagName = tags[i].trim();
    index = tagName.toLowerCase().indexOf(text);
    if (index !== -1) {
      if (index === 0) {
        firstResult.push(tagName);
        count++;
      } else if (tagName.indexOf(' ') === index - 1) {
        secondResult.push(tagName);
        count++;
      }
    }

    if (count > 10) {
      break;
    }
  }

  return {
    suggestions: firstResult.concat(secondResult)
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 1126
// module chunks = 0